import React, {useState} from 'react';
import {Modal} from "../../../utils/modal/Modal";
import {formatErrors} from "../../../constants";
import {useDispatch} from "react-redux";
import {toast} from "react-toastify";
import { updateFaqAction } from '../../../actions/faqAction';
import { InputProfile } from '../../../utils/input/InputProfile';

export function FaqModal({item, categoryId, trigger, triggerWrap, onSuccess}) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    id: item ? item.id : '',
    category_id: item ? item.category_id : categoryId,
    question: item ? item.question : '',
    answer: item ? item.answer : '',
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleOpen = (value) => {
    if (loading) {
      return;
    }
    setOpen(value);
  };

  const handleChangeForm = (field, value) => {
    setForm((form) => {
      return {...form, [field]: value};
    });
  };

  const handleSubmit = () => {
    if (loading) {
      return false;
    }
    let err = false;
    let errors = {};
    if (form.question.trim() === '') {
      err = true;
      errors.question = true;
    }

    setErrors(errors);
    if (err) {
      return false;
    }
    setLoading(true);

    dispatch(updateFaqAction(form)).then(() => {
      setLoading(false);
      setOpen(false);
      onSuccess();
    }).catch((e) => {
      setLoading(false);
      toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  return <Modal isStatic={true} open={open} handleOpen={handleOpen} trigger={trigger} triggerWrap={triggerWrap}>
    <React.Fragment>
      <div className="modal__title">{item ? "Изменить" : "Добавить"} запись</div>
      <div className="modal__wrap">
          <InputProfile type="text"
                        title="Вопрос"
                        name="question"
                        placeholder="Введите вопрос"
                        value={form.question}
                        error={errors.question || false}
                        disabled={loading}
                        onChange={(e) => handleChangeForm('question', e.target.value)}/>

          <InputProfile type="textarea"
                        title="Ответ"
                        name="question"
                        placeholder="Введите ответ"
                        value={form.answer}
                        error={errors.answer || false}
                        disabled={loading}
                        rows={10}
                        onChange={(e) => handleChangeForm('answer', e.target.value)}/>
              
      </div>
      <div className="modal__btns">
        <button type="button" className="modal__btn btn" onClick={handleSubmit} disabled={loading}>Сохранить</button>
      </div>
    </React.Fragment>
  </Modal>
};
